import { ICategory } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

export const getCategoriesFiltered = (
  categories: ICategory[],
  soldOutIds: number[]
): ICategory[] => {
  if (!Array.isArray(categories)) return []
  const soldOutSet = new Set(soldOutIds)
  return categories.map((category) => ({
    ...category,
    products: category.products.map((product) => ({
      ...product,
      soldOut: soldOutSet.has(product.id),
    })),
  }))
}
